import { default as Showdown } from "$showdown";
export { converter };

const converter = new Showdown.converter();

const orig = converter.makeHtml.bind(converter);
converter.makeHtml = (text, inline) =>
  orig(text, inline).replace(/<a href="([^#])/g, '<a target="_blank" href="$1');
